<script>
  import { derived } from 'svelte/store'
  import { ArrowUp, ArrowDown } from 'svelte-bootstrap-icons'

  import { createTable, Subscribe, Render } from 'svelte-headless-table'
  import {addSortBy} from 'svelte-headless-table/plugins'

  export let data
  export let columns
  export let config

  const table = createTable(data, config)
  const tableColumns = table.createColumns(columns.map(table.column))
  const {headerRows, rows, tableAttrs, tableBodyAttrs} = table.createViewModel(tableColumns)
</script>

<table class="table table-striped" {...$tableAttrs}>
  <thead>
    {#each $headerRows as headerRow (headerRow.id)}
      <Subscribe rowAttrs={headerRow.attrs()} let:rowAttrs>
        <tr {...rowAttrs}>
          {#each headerRow.cells as cell (cell.id)}
            <Subscribe attrs={cell.attrs()} let:attrs props={cell.props()} let:props>
              <th {...attrs} on:click={props.sort.toggle}>
                <Render of={cell.render()} />
                {#if props.sort.order === 'asc'}
                <ArrowDown />
                {:else if props.sort.order === 'desc'}
                <ArrowUp />
                {/if}
              </th>
            </Subscribe>
          {/each}
        </tr>
      </Subscribe>
    {/each}
  </thead>
  <tbody {...$tableBodyAttrs}>
    {#each $rows as row (row.id)}
      <Subscribe rowAttrs={row.attrs()} let:rowAttrs>
        <tr {...rowAttrs} >
          {#each row.cells as cell (cell.id)}
            <Subscribe attrs={cell.attrs()} let:attrs>
              <td {...attrs} style="vertical-align: middle">
                <Render of={cell.render()} />
              </td>
            </Subscribe>
          {/each}
        </tr>
      </Subscribe>
    {/each}
  </tbody>
</table>
